define('app/sdc/k/auto/height/sdc-k-auto-height',["$window"], function () {
	return {
		restrict: "A",
		controller: {
			constructor: ["$element", "$watch", "$scope", function ($element, $watch, $scope) {
				function adjustHeight(newHeight) {
					$element.height(newHeight || $element.width())
				}
				function window_onResize() {
					adjustHeight();
				}
				var getWidth = $element.width.bind($element),
					window_onResize = adjustHeight.bind(this, undefined),
					window = angular.element($window);
				$watch.controller(getWidth, adjustHeight);
				window.on("resize", window_onResize);
				$scope.$on("$destroy", function () {
					window.off("resize", window_onResize);
				});
			}]
		}
	};
});
